<template>
  <div class="home" :style="`background-color:${theme.bgColor}`">
    <div class="banner">
      <img class="banner-img" :src="albumInfo.thumbnail_url" alt="">
      <div class="banner-title">{{albumInfo.name}}</div>
    </div>
    <album-filter :photoNum="albumInfo.photo_count" :videoNum="albumInfo.video_count" :viewNum="albumInfo.view_photo_count" @change="change" @qrcode="showQrcode"></album-filter>
    <view-list :list="list" :theme="theme" :total="total" type="album" :page="page" @loadmore="loadmore" :sort="true" @gallerySort="gallerySort"></view-list>
    <Footer v-if="isLogin" :theme="theme"></Footer>
    <Qrcode v-show="isShowQrcode" :url='qrcodeSrc' :title='albumInfo.name' @click="closeQrcode" />
  </div>
</template>

<script>
import Footer from '@/components/footer.vue'
import GallerView from '@/components/galleryView'
import ViewList from '@/components/viewList'
import AlbumFilter from '@/components/albumFilter'
import Qrcode from '@/components/qrcode'
import API from '@/service/API'
import Session from "../utils/session";
import '@/assets/less/album.less'
export default {
  name: 'Home',
  data (){
    return {
      column: 2,
      albumInfo:{},
      qrcodeSrc: null,
      isShowQrcode: false,
      list: [],
      total: 0,
      theme: {
        footerColor: "#fff",
        bgColor: "#fff",
        searchBgColor: "#fff"
      },
      image_type: 'all',
      page: 1,
      ordering: '-create_time,-vote_num',
      hasNext: false,
      isInitWx: false
    }
  },
  computed:{
    isLogin: function(){
      return Session.get('userId')
    }
  },
  components: {
    GallerView,
    ViewList,
    AlbumFilter,
    Footer,
    Qrcode
  },
  mounted(){
    if(this.$route.path == '/' && !this.$route.query.albumCode){
      this.$router.push({
        path: '/albums'
      });
      return;
    }
    this.getList()
    document.title = this.$route.meta.title
  },
  activated(){
    const scrollTop = this.$route.meta.scrollTop;
    if (scrollTop) {
      window.scrollTo(0, scrollTop)
    }
  },
  methods: {
    change(type){
      this.$data.page = 1;
      this.$data.image_type = type;
      this.$data.list = [];
      this.getList()
    },
    gallerySort(flag){
      if(flag){
        this.$data.ordering = 'create_time,vote_num';
      } else {
        this.$data.ordering = '-create_time,-vote_num';
      }
      this.$data.page = 1;
      this.$data.list = [];
      this.getList();
    },
    getList(){
      let albumCode = Session.get('albumCode')
      const params = this.$route.params
      if(albumCode){
        params.album_code = albumCode
        delete params.album
      }
      params.page = this.$data.page;
      params.image_type = this.$data.image_type;
      params.ordering = this.$data.ordering;
      API.getPhotoList(params).then( res => {
        let { data, hasNext } = res;
        if(data.album){
          this.$data.albumInfo = data.album
          document.title = data.album.name
        }
        this.$data.hasNext = hasNext;
        this.$data.theme = {
          bgColor: res.data.album.bg_color,
          footerColor: res.data.album.footer_menu_bg_color,
          searchBgColor: res.data.album.search_bar_bg_color,
        }
        this.$data.total = data.album.photo_count + data.album.video_count
        if(data.photos){
          let newList = []
          data.photos.map(item => {
            newList = newList.concat(item.ps)
          })
          this.$data.list = this.$data.list.concat(newList)
        }
        // 初始化微信分享
        if(!this.$data.isInitWx && window.wx){
          this.$data.isInitWx = true;
          const url = location.href;
          const origin = location.origin
          API.getWxConfgi(url).then( res => {
            wx.config({ ...res});
            wx.ready(function () {
              wx.updateAppMessageShareData({
                title: data.album.name, // 分享标题  取标题
                desc: data.album.desc, // 分享描述  取标题
                link: `${origin}?albumCode=${data.album.code}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致，  取值取当前网页路径即可
                imgUrl: data.album.title_image_url, // 分享图标， 取值取相册返回的title_image_url字段值
                success: function () {

                }
              })
            });
          })
        }
      })
    },
    loadmore(){
      if(this.$data.hasNext){
        this.$data.page++
        this.getList()
      }
    },
    showQrcode(){
      // 生成二维码
      if(!this.qrcodeSrc){
        let params = {
          url: location.href
        }
        API.qrcode(params).then( data => {
          this.qrcodeSrc = data.b64,
          this.isShowQrcode = true
        })
      } else {
        this.isShowQrcode = true
      }
    },
    closeQrcode(){
      this.isShowQrcode = false
    }
  }
}
</script>